export const RECONCILIATION_CATEGORIES = Object.freeze({
  held: { label: "Rappels sous garde", count: "held", reason: "HELD_PENDING_REVIEW", explanation: "Une vérification est requise avant toute modification." },
  indeterminate: { label: "Exécutions incertaines", count: "indeterminate", reason: "EXECUTION_UNCERTAIN", explanation: "Le résultat de l’exécution doit être rapproché des appels réels." },
  reservations: { label: "Réservations à vérifier", count: "uncertainReservations", reason: "RESERVATION_UNRESOLVED", explanation: "Une réservation peut correspondre à un appel en cours." },
  legacy_ni: { label: "Anciens suivis automatiques NI", count: "legacyAutomaticNI", reason: "LEGACY_AUTOMATIC_NI", explanation: "Suivis automatiques associés à une qualification « pas intéressé »." },
});
export const RECONCILIATION_PAGE_LIMIT = 25;

export const parseReconciliationResponse = (response, category, page) => {
  const data = response?.data?.data;
  const def = RECONCILIATION_CATEGORIES[category];
  const countKeys = ["held", "heldIdentifiers", "indeterminate", "uncertainReservations", "legacyAutomaticNI"];
  if (!def || response?.data?.status !== "success" || data?.readOnly !== true || data.category !== category
      || data.page !== page || !Number.isInteger(data.limit) || data.limit < 1 || data.limit > 50
      || !Number.isInteger(data.total) || data.total < 0 || !Array.isArray(data.items) || data.items.length > data.limit
      || typeof data.hasMore !== "boolean" || typeof data.paginationLimitReached !== "boolean"
      || !Number.isFinite(+new Date(data.checkedAt)) || !data.checkedAt
      || countKeys.some((key) => !Number.isInteger(data.counts?.[key]) || data.counts[key] < 0)
      || data.items.some((item) => !item || typeof item.id !== "string" || item.id.length > 256
        || item.category !== category || item.reasonCode !== def.reason || item.requiresReview !== true)) {
    throw new Error("Diagnostic indisponible ou réponse invalide");
  }
  return data;
};

export const formatDiagnosticDate = (value) => value && Number.isFinite(+new Date(value))
  ? new Date(value).toLocaleString("fr-FR", { timeZone: "UTC" }) + " UTC" : "Non renseigné";
